if (!customElements.get('scroll-item')) {
  class ScrollItem extends HTMLElement {
    constructor() {
      super();

      // Find the button with scroll functionality
      const scrollButton = this.querySelector('a[data-scroll-id]');
      this.forms = document.querySelectorAll('.legona-form-section');

      if (scrollButton) {
        scrollButton.addEventListener('click', (e) => {
          e.preventDefault();

          const scrollId = scrollButton.getAttribute('data-scroll-id');
          // Use querySelector to find element by data-target-id attribute
          const targetElement = document.querySelector(`[data-target-id="${scrollId}"]`);

          if (targetElement) {
            // Check if targetElement has 'hidden-form' class
            if (targetElement.classList.contains('hidden-form')) {

              this.forms.forEach(form => {
                if (form !== targetElement) {
                  form.classList.add('hidden-form');
                }
              });
              targetElement.classList.remove('hidden-form');
            }
            setTimeout(() => {
              const elementPosition = targetElement.offsetTop - 100;
              window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
              });
              targetElement.click();
            }, 100);
          }
        });
      }
    }
  }
  customElements.define('scroll-item', ScrollItem);
}
